import { Box, Skeleton } from '@mui/material';
import { ShippingInfoBox } from './shipping-info-box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LoadingShippingInfo = function LoadingShippingInfo() {
  return /*#__PURE__*/_jsxs(ShippingInfoBox, {
    "data-element": "ShippingInfoBox",
    "data-component": "LoadingShippingInfo",
    "data-source-file": "loading.tsx",
    children: [/*#__PURE__*/_jsx(Skeleton, {
      width: "100%",
      height: 80,
      "data-element": "Skeleton",
      "data-component": "LoadingShippingInfo",
      "data-source-file": "loading.tsx"
    }), /*#__PURE__*/_jsx(Skeleton, {
      width: "100%",
      height: 80,
      "data-element": "Skeleton",
      "data-source-file": "loading.tsx"
    }), /*#__PURE__*/_jsx(Skeleton, {
      width: "100%",
      height: 80,
      "data-element": "Skeleton",
      "data-source-file": "loading.tsx"
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      },
      "data-element": "Box",
      "data-source-file": "loading.tsx",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        sx: {
          mr: 3,
          width: 1
        },
        height: 80,
        "data-element": "Skeleton",
        "data-source-file": "loading.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        sx: {
          width: 1
        },
        height: 80,
        "data-element": "Skeleton",
        "data-source-file": "loading.tsx"
      })]
    }), /*#__PURE__*/_jsx(Skeleton, {
      width: "100%",
      height: 80,
      "data-element": "Skeleton",
      "data-source-file": "loading.tsx"
    })]
  });
};

export default LoadingShippingInfo;